import { Controller } from "@hotwired/stimulus"
import Splide from "@splidejs/splide"

// Slider/Carousel Controller
// A reusable component for horizontal sliding panels with swipe gestures
export default class extends Controller {
  static values = {
    autoAdvance: { type: Number, default: 0 }, // Seconds, 0 = disabled
    loop: { type: Boolean, default: true },
    perPage: { type: Number, default: 1 },
    gap: { type: String, default: "1rem" },
    arrows: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    type: { type: String, default: "slide" } // 'slide', 'loop', or 'fade'
  }

  connect() {
    this.initializeSplide()
  }

  initializeSplide() {
    const options = {
      type: this.typeValue,
      rewind: this.loopValue,
      perPage: this.perPageValue,
      gap: this.gapValue,
      arrows: this.arrowsValue,
      pagination: this.paginationValue,
      autoplay: this.autoAdvanceValue > 0,
      interval: this.autoAdvanceValue * 1000, // Convert seconds to milliseconds
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,
      // Better mobile experience
      drag: true,
      flickPower: 300,
      // Accessibility
      accessibility: true,
      // Performance
      lazyLoad: 'nearby',
    }

    this.splide = new Splide(this.element, options)

    // Pause autoplay on any user interaction
    if (this.autoAdvanceValue > 0) {
      this.setupAutoplayPause()
    }

    this.splide.mount()
  }

  setupAutoplayPause() {
    // Pause on touch/click
    this.element.addEventListener('touchstart', () => {
      if (this.splide && this.splide.Components.Autoplay) {
        this.splide.Components.Autoplay.pause()
      }
    }, { passive: true })

    this.element.addEventListener('mousedown', () => {
      if (this.splide && this.splide.Components.Autoplay) {
        this.splide.Components.Autoplay.pause()
      }
    })
  }

  disconnect() {
    if (this.splide) {
      this.splide.destroy()
      this.splide = null
    }
  }
}
